var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7771 14.5399L19.5247 18.2866L18.2866 19.5247L14.5399 15.7771C13.1458 16.8947 11.4118 17.5025 9.625 17.5C5.278 17.5 1.75 13.972 1.75 9.625C1.75 5.278 5.278 1.75 9.625 1.75C13.972 1.75 17.5 5.278 17.5 9.625C17.5025 11.4118 16.8947 13.1458 15.7771 14.5399ZM14.0219 13.8906C15.1321 12.7485 15.7522 11.2178 15.75 9.625C15.75 6.24137 13.0086 3.5 9.625 3.5C6.24137 3.5 3.5 6.24137 3.5 9.625C3.5 13.0086 6.24137 15.75 9.625 15.75C11.2178 15.7522 12.7485 15.1321 13.8906 14.0219L14.0219 13.8906Z",
    fill: "#0D326F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSearch);
export default __webpack_public_path__ + "static/media/header_search.87cce0fb20d0642b5e624b4b6edd26d0.svg";
export { ForwardRef as ReactComponent };